<template>
  <div>
    <header id="mainHeader">
      <div class="container-fluid row align-items-center justify-content-end m-0 p-0 h-100">
        <div class="version-display">
          <small>v{{ version }}</small>
        </div>
        <div class="col-auto p-0">
          <div class="d-flex align-items-center">
            <p class="text-right m-0">
              <small>{{ date }}<br />{{ time }}</small>
            </p>
          </div>
        </div>
      </div>
    </header>
    <router-view />
  </div>
</template>
<script>
import packageInfo from '../package.json';

const dateOpts = { weekday: 'long', month: 'long', day: 'numeric' };
const timeOpts = { hour: '2-digit', minute: '2-digit' };
export default {
  async created() {
    setInterval(() => {
      this.date = new Date().toLocaleDateString('fr-FR', dateOpts);
      this.time = new Date().toLocaleTimeString('fr-FR', timeOpts).replace(':', 'H');
    }, 5000);
  },
  data() {
    return {
      date: new Date().toLocaleDateString('fr-FR', dateOpts),
      time: new Date().toLocaleTimeString('fr-FR', timeOpts).replace(':', 'H'),
      version: packageInfo.version,
    };
  },
};
</script>

<style scoped>
.version-display {
  position: fixed;
  bottom: 16px;
  right: 16px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.8em;
  z-index: 1000;
  pointer-events: none;
}

.version-display small {
  background: rgba(0, 0, 0, 0.2);
  padding: 2px 6px;
  border-radius: 3px;
  backdrop-filter: blur(5px);
}
</style>
